export const isLetter = (value: string) => /[a-zA-Z]{1}/g.test(value)
